import { PublicKey, SymmetricKey } from '@/shared/lib/secure-json/core/crypto-core/types';
import { EncryptedData } from '@/shared/lib/secure-json/core/secure-json-encryptor/types';

export type Key = string;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type DecryptedData = any;
export type EncryptedSymmetricKey = string;
export enum Permission {
  READ = 'READ',
  WRITE = 'WRITE',
}
export type ItemSignature = string;

/* TODO rework */
export type CollectionItem = {
  decryptedData?: DecryptedData;
  decryptedSymmetricKey?: SymmetricKey;
  permissions: Map<PublicKey, Set<Permission>>;
  signature?: ItemSignature;
  // Encrypted
  encryptedData?: EncryptedData | undefined;
  encryptedSymmetricKeys: Map<PublicKey, EncryptedSymmetricKey>;
};

export type CollectionItemV2 = {
  data: DecryptedData;
  symmetricKey: SymmetricKey;
  permissions: Map<PublicKey, Set<Permission>>;
  signature?: ItemSignature;
};

export type CollectionItemV2Encrypted = {
  encryptedData: EncryptedData;
  encryptedSymmetricKeys: Map<PublicKey, EncryptedSymmetricKey>;
  permissions: Map<PublicKey, Set<Permission>>;
  signature?: ItemSignature;
};

export interface ISetParameters {
  key: Key;
  data: DecryptedData;
  publicKeys?: Array<PublicKey>;
  permissions?: Map<PublicKey, Set<Permission>>;
}

// export interface CollectionSymmetricKey {
//   decryptedValue?: SymmetricKey;
//   encryptedValue?: string;
// }

// export type CollectionSymmetricKeys = Map<PublicKey, CollectionSymmetricKey>;

export class RecordNotFoundError extends Error {
  constructor() {
    super('Record not found');
  }
}
